// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"86db61e2","180":"b013a147","285":"da9f2666","345":"bac016d2","360":"cd14f13c","453":"35a91684","778":"c7b4c0e3"}[chunkId] + ".chunk.js";
};